import { Grid, List } from "@material-ui/core";
import { PagedResponse } from "@ofqual/portal-core/core/types";
import React from "react";
import { PublicEnquiryModel } from "../../../domain/PublicEnquiry";
import { ItemsState } from "../../../redux/state";
import { TileProps } from "../../../services/core/types";
import { ItemsList } from "../../list/ItemsList";

export const CaseListTile: React.FC<TileProps> = ({ tile }) => {
  const peData: PagedResponse<PublicEnquiryModel> = {
    data: (tile.parsedData as unknown) as PublicEnquiryModel[],
    count: 0,
    page: 0,
    pageSize: 0,
  };

  const peStateDto: ItemsState = {
    response: peData,
    status: "LOADED",
    hasData: tile.data.length > 0,
  };

  return (
    <Grid item xs={12} md={12}>
      <ItemsList state={peStateDto} dashboardRedirectUrl={true} />
    </Grid>
  );
};
